import { render, staticRenderFns } from "./routerMenu.vue?vue&type=template&id=9adea056&scoped=true&"
import script from "./routerMenu.vue?vue&type=script&lang=js&"
export * from "./routerMenu.vue?vue&type=script&lang=js&"
import style0 from "./routerMenu.vue?vue&type=style&index=0&id=9adea056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9adea056",
  null
  
)

export default component.exports